import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { TableConfig, DEFAULT_PAGE_SIZE } from "../../configs/constants";
import { IndividualHandlingSearchRequest } from "../api-interfaces";
import { CODE_MASTER } from "../../components/default-constants";

interface UserList {
  searchCriteria: IndividualHandlingSearchRequest;
  tableConfig: TableConfig;
}

export const INITIAL_SEARCH_CRITERIA: IndividualHandlingSearchRequest = {
  applicationNo: "",
  startDate: "",
  endDate: "",
  contractType: "",
  contractRoute: "",
  companyName: "",
  merchantName: "",
  individualHandlingReason: "",
  status: CODE_MASTER["CONFIRMATION_STATUS"][0].value,
  timestamp: -1,
};

const initialState: UserList = {
  searchCriteria: INITIAL_SEARCH_CRITERIA,
  tableConfig: {
    pageSize: DEFAULT_PAGE_SIZE,
    pageIndex: 1,
    columnWidths: [],
  },
};

const individualHandlingListSlice = createSlice({
  name: "individualHandlingList",
  initialState,
  reducers: {
    setSearchCriteria: (
      state,
      action: PayloadAction<IndividualHandlingSearchRequest>
    ) => {
      state.searchCriteria = action.payload;
      state.tableConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: 1,
        columnWidths: [],
      };
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageIndex = action.payload;
    },
    setColumnWidths: (state, action: PayloadAction<number[]>) => {
      state.tableConfig.columnWidths = action.payload;
    },
    changePageSize: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageSize = action.payload;
      state.tableConfig.pageIndex = 1;
    },
  },
});

export const {
  setSearchCriteria,
  setPageIndex,
  setColumnWidths,
  changePageSize,
} = individualHandlingListSlice.actions;

export default individualHandlingListSlice.reducer;
